import { render, staticRenderFns } from "./lossList.vue?vue&type=template&id=1bc8b828&scoped=true&lang=html&"
import script from "./lossList.vue?vue&type=script&lang=js&"
export * from "./lossList.vue?vue&type=script&lang=js&"
import style0 from "./lossList.vue?vue&type=style&index=0&id=1bc8b828&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc8b828",
  null
  
)

export default component.exports